<template>
  <div :class="['c-spinner', { 'c-spinner--is-small': isSmall, 'c-spinner--is-inversed': isInversed }]">
    <div class="c-spinner__dot"></div>
    <div class="c-spinner__dot"></div>
    <div class="c-spinner__dot"></div>
    <div class="c-spinner__dot"></div>
    <div class="c-spinner__dot"></div>
    <div class="c-spinner__dot"></div>
  </div>
</template>

<script>
  export default {
    name: 'BaseSpinner',

    props: {
      isSmall: {
        type: Boolean,
        default: false
      },
      isInversed: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
